// Slice de puerta
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  puertas: [],
  puertaSeleccionada: null,
  isLoadingPuertas: false,
  errorPuertas: null,
  failurePuertas: false,
};

const puertaSlice = createSlice({
  name: "puerta",
  initialState,
  reducers: {
    setPuertas: (state, action) => {
      state.puertas = action.payload;
      state.isLoadingPuertas = false;
      state.failurePuertas = false;
    },
    agregarPuerta: (state, action) => {
      state.puertas.unshift(action.payload);
      state.isLoadingPuertas = false;
      state.failurePuertas = false;
    },
    actualizarPuerta: (state, action) => {
      const index = state.puertas.findIndex(
        (p) => p.uid === action.payload.uid
      );
      if (index !== -1) {
        state.puertas[index] = action.payload;
      }
      state.isLoadingPuertas = false;
      state.failurePuertas = false;
    },
    setPuertaSeleccionada: (state, action) => {
      state.puertaSeleccionada = action.payload;
    },
    setLoadingPuertas: (state, action) => {
      state.isLoadingPuertas = action.payload;
    },
    puertaFailure: (state, action) => {
      state.failurePuertas = true;
      state.isLoadingPuertas = false;
      state.errorPuertas = action.payload;
    },
    resetPuertas: (state) => {
      state.puertas = [];
      state.puertaSeleccionada = null;
      state.isLoadingPuertas = false;
      state.errorPuertas = null;
      state.failurePuertas = false;
    },
  },
});

export const {
  setPuertas,
  agregarPuerta,
  actualizarPuerta,
  setPuertaSeleccionada,
  setLoadingPuertas,
  puertaFailure,
  resetPuertas,
} = puertaSlice.actions;

export default puertaSlice.reducer;
